module.exports = __webpack_public_path__ + "img/商超-多多买菜.f480b9fa.jpg";